import Box from '@mui/material/Box'
import LocationListView from './LocationListView'

const LocationListAdmin = () => {
    return (
        <Box sx={{ overflowY: 'hidden', width: '100%' }}>
            <LocationListView mock />
        </Box>
    )
}

export default LocationListAdmin
